export function parseTextBySomeLength(text: string, from: number, to: number) {
  const regex = `.{${from},${to}}`;
  return text.match(regex);
}

export const hasSpaces = (value: string) => {
  const regex = new RegExp(/\s/g);
  return regex.test(value);
};
